import { Static, Type } from '@sinclair/typebox';
import { AddressSchema } from './professional';

export const AddressAutocompletePredictionSchema = Type.Object({
  description: Type.String(),
  place_id: Type.String(),
});

export const AddressAutocompleteResponseSchema = Type.Object({
  predictions: Type.Array(AddressAutocompletePredictionSchema),
});

export const AddressDetailsResponseSchema = Type.Object({
  address: AddressSchema,
});

export type AddressAutocompletePrediction = Static<typeof AddressAutocompletePredictionSchema>;
export type AddressAutocompleteResponse = Static<typeof AddressAutocompleteResponseSchema>;
export type AddressDetailsResponse = Static<typeof AddressDetailsResponseSchema>;
